import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import {
  Box, Button, withStyles, Paper, RadioGroup,
  FormControlLabel, Radio,
  Table, TableBody,
  TableCell, TableContainer, TextField,
  TableHead, TableRow, TableSortLabel,
} from '@material-ui/core';
import { ArrowForwardIos as ArrowForwardIosIcon, ArrowBackIos as ArrowBackIosIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import FormTitle from '../../../../components/atoms/formTitle/FormTitle';
import SearchSelectBox from '../../../../components/atoms/searchSelectBox/SearchSelectBox';
import Pagination from '../../../../components/atoms/pagination/Pagination';

// #region css
const styles = (theme) => ({
  root: {
    marginBottom: theme.spacing(10),
  },
  textCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  phoneTextField: {
    width: '10ch',
    [theme.breakpoints.down('xs')]: {
      width: '75px',
    },
  },
  smallTextField: {
    width: '10ch',
    [theme.breakpoints.down('xs')]: {
      width: '80px',
    },
  },
  smallTextFieldDate: {
    width: '10ch',
    [theme.breakpoints.down('xs')]: {
      width: '70px',
    },
  },
  button: {
    marginRight: '20px',
    [theme.breakpoints.down('xs')]: {
      marginRight: '10px',
      marginBottom: '20px',
    },
  },
  highlight: {
    backgroundColor: '#E8F0FE',
  },
  title: {
    flex: '1 1 50%',
  },
  tableLabel: {
    verticalAlign: 'baseline',
  },
  emptyTableCell: {
    textAlign: 'center',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  result: {
    marginRight: '20px',
    [theme.breakpoints.down('xs')]: {
      marginRight: '0px',
      marginBottom: '20px',
    },
  },
  footer: {
    zIndex: '1000',
    width: '100%!important',
    position: 'fixed!important',
    bottom: '0',
    left: '0',
    background: '#fff',
    boxShadow: '0 -8px 10px -9px rgba(0,0,0,.05), 0 3px 14px 2px rgba(0,0,0,.01), 0 5px 5px -3px rgba(0,0,0,.05)',
  },
});
// #endregion

const HEAD_CELL = [
  { id: 'memberName', numeric: false, label: '会員番号' },
  { id: 'name', numeric: false, label: '名前' },
  { id: 'nameFuri', numeric: false, label: '名前フリガナ' },
  { id: 'email', numeric: false, label: 'メールアドレス' },
];

class Conditoin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: 'asc',
      orderBy: '',
    };
  }

  getTableHeadCell = (headCell) => {
    const { isMain, classes } = this.props;
    const { order, orderBy } = this.state;
    if (headCell.id === 'store' && !isMain) {
      return null;
    }
    return (
      <TableCell
        key={headCell.id}
        align="left"
        padding="default"
        sortDirection={orderBy === headCell.id ? order : false}
      >
        <TableSortLabel
          active={orderBy === headCell.id}
          direction={orderBy === headCell.id ? order : 'asc'}
          onClick={this.createSortHandler(headCell.id)}
          className={classes.tableLabel}
        >
          {headCell.label}
          {orderBy === headCell.id ? (
            <span className={classes.visuallyHidden}>
              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
            </span>
          ) : null}
        </TableSortLabel>
      </TableCell>
    );
  }

  handleRequestSort = (_, property) => {
    const { order, orderBy } = this.state;

    const isAsc = orderBy === property && order === 'asc';

    this.setState({ order: isAsc ? 'desc' : 'asc', orderBy: property });
  };

  createSortHandler = (property) => (event) => {
    this.handleRequestSort(event, property);
  };

  handleChange = (e) => {
    this.props.onChange(e, this.props.type);
  }

  handleRadioChange = (e) => {
    const event = {
      target: {
        name: 'gender',
        value: e.target.value,
      },
    };
    this.props.onChange(event, this.props.type);
  }

  handleNext = () => {
    const { type, activeStep } = this.props;
    this.props.onChangeStep(type, activeStep + 1);
  }

  handleBack = () => {
    const { type, activeStep } = this.props;
    this.props.onChangeStep(type, activeStep - 1);
  }

  hasError = () => {
    const { errorMessage } = this.props;
    return Object.values(errorMessage).some((v) => v !== '');
  }

  handleSave = () => {
    this.props.onSave(this.props.type);
  }

  render() {
    const {
      classes,
      data,
      initSelectValues,
      onSearch,
      members,
      onChangePage,
      onChangeRowsPerPage,
      fromDetail,
    } = this.props;

    return (
      <div className={classes.root}>
        <Box my={3}>
          <Alert style={{ display: this.hasError() ? '' : 'none' }} severity="error">入力エラーがあります。確認してください。</Alert>
        </Box>

        <Paper elevation={0} variant="outlined">
          <Box p={3}>
            <Box mb={3}>
              <FormTitle title="性別" />
              <RadioGroup
                row
                value={data.gender}
                onChange={this.handleRadioChange}
              >
                <FormControlLabel value="1" control={<Radio />} label="男性" />
                <FormControlLabel value="2" control={<Radio />} label="女性" />
                <FormControlLabel value="0" control={<Radio />} label="設定なし" />
              </RadioGroup>
            </Box>
            <Box mb={3} width="80%">
              <FormTitle title="年代" />
              <SearchSelectBox
                name="age"
                onChange={this.handleChange}
                value={data.age}
                options={initSelectValues.ages}
              />
            </Box>
            <Box width="80%" mb={3}>
              <FormTitle title="契約商品種類" />
              <SearchSelectBox
                name="contractProductType"
                value={data.contractProductType}
                options={initSelectValues.contractProductTypes}
                onChange={this.handleChange}
              />
            </Box>
            <Box mb={3} width="40%">
              <FormTitle title="会員番号" />
              <TextField
                name="memberNo"
                id="memberNo"
                variant="outlined"
                onChange={this.handleChange}
                autoComplete="off"
                value={data.memberNo}
                inputProps={{ maxLength: 10 }}
                fullWidth
              />
            </Box>
          </Box>
        </Paper>

        <Box mt={2} pb={5}>
          <Paper elevation={0} variant="outlined">
            <TableContainer>
              <Table
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    {HEAD_CELL.map((headCell) => this.getTableHeadCell(headCell))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(members.content ?? []).map((row) => (
                    <>
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={row.id}
                      >
                        <TableCell>
                          {row.memberNumber}
                        </TableCell>
                        <TableCell>
                          {row.name}
                        </TableCell>
                        <TableCell>
                          {row.nameKana}
                        </TableCell>
                        <TableCell>
                          {row.email}
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                  {(members.content ?? []).length < 1 && (
                    <TableRow>
                      <TableCell className={classes.emptyTableCell} colSpan={6}>
                        データがありません
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Pagination
              totalElements={members?.totalElements ?? 0}
              rowsPerPage={data?.records ?? 0}
              page={data?.page ?? 0}
              onChangePage={onChangePage}
              onChangeRowsPerPage={onChangeRowsPerPage}
            />
          </Paper>
        </Box>

        <Box position="fixed" pb={2} className={classes.footer}>
          <Box align="center" textAlign="center" mt={2} display={{ xs: 'block', sm: 'flex' }} justifyContent="center">
            {!fromDetail && (
              <Button
                variant="contained"
                onClick={this.handleBack}
                startIcon={<ArrowBackIosIcon />}
                className={classes.button}
              >
                戻る
              </Button>
            )}
            <Box className={classes.result} display="flex" align="center" justifyContent="center">
              <Box display="flex" sx={{ alignItems: 'end' }}>
                <div>検索結果</div>
              </Box>
              <Box mr={1} ml={1} display="flex" sx={{ fontSize: '2rem', fontWeight: 'bold' }}>
                <Box mb={-1}>{members?.totalElements ?? 0}</Box>
              </Box>
              <Box display="flex" sx={{ alignItems: 'end' }}>
                <div>件</div>
              </Box>
            </Box>
            <Button
              color="primary"
              variant="contained"
              onClick={onSearch}
              className={classes.button}
            >
              検索
            </Button>
            {!fromDetail && (members.content ? members.content.length : 0) > 0 && (
              <Button
                color="primary"
                variant="contained"
                onClick={this.handleNext}
                className={classes.button}
                endIcon={<ArrowForwardIosIcon />}
              >
                次へ
              </Button>
            )}
            {fromDetail && (members.content ? members.content.length : 0) > 0 && (
              <Button
                color="primary"
                variant="contained"
                onClick={this.handleSave}
                className={classes.button}
              >
                保存
              </Button>
            )}
          </Box>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
});

export default withStyles(styles)(withRouter(connect(mapStateToProps)(Conditoin)));
